import { render, staticRenderFns } from "./BusinessMemberShippedHistoryList.vue?vue&type=template&id=7f1d18ce"
import script from "./BusinessMemberShippedHistoryList.vue?vue&type=script&lang=js"
export * from "./BusinessMemberShippedHistoryList.vue?vue&type=script&lang=js"
import style0 from "./BusinessMemberShippedHistoryList.vue?vue&type=style&index=0&id=7f1d18ce&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports